export default __webpack_public_path__ + "static/media/youll-never-get-out.b9c89bdf.m4a";